export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg font-heading">
                555
              </span>
              <span className="text-xl font-heading text-background-50">555影视</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              555影视致力于打造最新电影、高清电影大全免费在线观影平台，每日同步更新热门影视资源，高清片源流畅播放不缓冲，满足每一位影迷的追影需求。
            </p>
          </div>

          <div>
            <h4 className="text-background-100 font-medium text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '精彩预告', href: '#media' },
                { label: '最新快讯', href: '#updates' },
                { label: '热门榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-background-400 hover:text-primary-400 text-sm whitespace-nowrap cursor-pointer transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-100 font-medium text-sm mb-4">电影分类</h4>
            <ul className="space-y-2.5">
              {['动作大片', '喜剧电影', '科幻巨制', '悬疑推理', '动画电影'].map((cat) => (
                <li key={cat}>
                  <span className="text-background-400 text-sm whitespace-nowrap">{cat}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-100 font-medium text-sm mb-4">合作伙伴</h4>
            <p className="text-background-500 text-sm">诚邀优质影视内容伙伴加入，共建高清电影资源共享平台。</p>
          </div>
        </div>

        <div className="border-t border-background-800/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 555影视。本站所有资源均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-background-500 text-xs whitespace-nowrap">最新电影 · 高清电影 · 免费在线观看</span>
          </div>
        </div>
      </div>
    </footer>
  );
}